/**
 * Helper to sort available languages based
 * on the users browser language preferences
 */

import { LanguageMap } from "../types/transcriptApiTypes";

// sort available languages based on browser lang preferences
const sortLangs = (availLangs: LanguageMap, prefLangs: string[]) => {
  let sortedObj: LanguageMap = {};
  let remainderObj: LanguageMap = {};

  // order the preflangs that are available first
  Object.keys(prefLangs).forEach((lang: string) => {
    const key = prefLangs[lang];
    if (availLangs[key]) {
      sortedObj[key] = availLangs[key];
    }
  });

  // add the rest of the available langs to the end
  Object.keys(availLangs).forEach((lang: string) => {
    if (!prefLangs.includes(lang)) {
      remainderObj[lang] = availLangs[lang];
    }
  });

  let combinedSort: LanguageMap = {
    ...sortedObj,
    ...remainderObj,
  };

  return combinedSort;
};

export default sortLangs;
